import { lazy } from 'react';

const CertifiedAvailableManufacturerPageConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}

	},
	routes: [
		{
			path: '/certificates/manufacturer/avaibles',
			component: lazy(() => import('./CertifiedAvailablePage'))
		}
	]
};

export default CertifiedAvailableManufacturerPageConfig;
